<template>
  <div class="wl-add-product mb-3">
    <b-overlay :show="loading" v-if="!is_guest" class="d-inline-block">
      <b-dropdown
        variant="primary"
        class="mb-1 mb-lg-0"
        size="sm"
        split
        :text="buttonText"
        @click="onClick"
      >
        <b-dropdown-item
          @click="addToList(list)"
          v-for="list in editable_lists"
          :key="list.id"
          >Add to '{{ list.list_title | truncate(20) }}'</b-dropdown-item
        >
        <b-dropdown-item
          :href="'/wine-list/new/' + sku"
          v-if="editable_lists.length > 0"
          >Create New Wine List</b-dropdown-item
        >
      </b-dropdown>
    </b-overlay>
    <!-- mb-0: jbtrade-homepage.css gives .btn-primary a 30px bottom margin, which pushed the
         tech sheet button down next to the product text (UAT, JTHR-28). -->
    <b-button v-else href="/log-in" variant="primary" size="sm" class="mb-0"
      >Log in to Create a Wine List</b-button
    >
    <!-- One-click tech sheet (JTHR-28), for guests and logged-in users alike. The product page
         renders its own button (single-product.blade.php), so formats there pass tech-sheet=false. -->
    <b-button
      v-if="sku && techSheet"
      :href="'/download/tech-sheet?sku=' + encodeURIComponent(sku)"
      variant="outline-primary"
      size="sm"
      class="wl-tech-sheet"
      rel="nofollow"
      >Download tech sheet</b-button
    >
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  props: {
    sku: {
      type: String,
    },
    techSheet: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    addToList(list) {
      this.loading = true;
      this.$store.commit("winelist/set_last_added_to", {
        id: list.id,
        list_title: list.list_title,
      });
      this.$store
        .dispatch("winelist/add_to_list", {
          list_id: list.id,
          sku: this.sku,
        })
        .then(() => {
          this.loading = false;
        })
        .catch((err) => {
          this.showError(
            "Error",
            err.response.data.message ??
              "Sorry, this item couldn't be added to the list. Please try again later."
          ).then(() => {
            this.loading = false;
          });
        });
    },
    onClick() {
      if (!this.last_added_to) {
        window.location = "/wine-list/new/" + this.sku;
      } else {
        this.addToList(this.last_added_to);
      }
    },
  },
  computed: {
    buttonText() {
      if (!this.last_added_to) {
        return "Create new wine list";
      } else {
        return (
          "Add to '" +
          this.$options.filters.truncate(this.last_added_to.list_title, 20) +
          "'"
        );
      }
    },
    ...mapGetters("winelist", ["last_added_to"]),
    ...mapGetters("winelist", ["editable_lists"]),
    ...mapState("user", ["is_guest"]),
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style scoped>
/* Guest CTAs (UAT, JTHR-28): "Log in to Create a Wine List" + "Download tech sheet".
   One-column grid with equal rows, so both buttons always share the same width AND height.
   Desktop: up to 240px, right-aligned by the column. Below lg: full width of the product column.
   Only direct .btn children are styled, so the logged-in wine list dropdown is unaffected. */
.wl-add-product {
  display: inline-grid;
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr;
  row-gap: 0.5rem;
  width: 240px;
  max-width: 100%;
}
.wl-add-product > .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 !important;
  padding: 0.6rem 1rem;
  white-space: normal;
  line-height: 1.3;
  font-weight: 500;
}
@media (max-width: 991.98px) {
  .wl-add-product {
    display: grid;
    width: 100%;
    margin-top: 0.5rem;
  }
}
</style>
